import type { CarBewertung } from '@ahd/shared/types/ahd-cars/car/bewertung';
import axios from './Axios';
import { getAxiosHeader, urlServicesRelease } from './AxiosVars';

export function getAllBewertungen(idCar) {
    const url = urlServicesRelease + '/cars/v4/inzahlungnahme/' + idCar;
    return axios<CarBewertung[]>({
        title: 'Abrufen aller Bewertungen',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function getAktBewertung(idCar) {
    const url = urlServicesRelease + '/cars/v4/inzahlungnahme/' + idCar + '/akt';
    return axios({
        title: 'Abrufen der Bewertung',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function saveBewertung(idCar, strData) {
    const url = urlServicesRelease + '/cars/v4/inzahlungnahme/' + idCar;
    return axios({
        title: 'Speichern der Bewertung',
        method: 'post',
        url: url,
        data: strData,
        headers: getAxiosHeader(),
    });
}
